<!-- <div class="modal-title" mat-dialog-title>
  <div class="logo">
    <img src="assets/images/se-logo-red-gray.svg" height="48" alt="Suitestensa logo" />
  </div>
</div>
 -->
<mat-dialog-content class="mat-typography">
    <h2 class="broker-modal-title">{{ title() }}</h2>

    <h3 class="modal-message">{{ message() }}</h3>

    @if (dataSource().length) {
        <ag-grid-angular
            (gridReady)="onGridReady($event)"
            (gridSizeChanged)="onGridSizeChanged($event)"
            [autoSizeStrategy]="autoSizeStrategy"
            [columnDefs]="columnDefs"
            [floatingFiltersHeight]="40"
            [rowHeight]="40"
            [overlayNoRowsTemplate]="noRowsTemplate"
            [rowData]="dataSource()"
            [modules]="agGridModuls"
            [theme]="agGridTheme"
            style="width: 100%; height: 100%; padding: 0px 10px 10px"
        >
        </ag-grid-angular>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    @if (hasOk()) {
        <button mat-button class="btn-themed" [mat-dialog-close]="true" (click)="onOk()">
            {{ translateService.instant("OK") }}
        </button>
    }
    @if (hasYes()) {
        <button mat-button class="btn-themed" (click)="onYes()">{{ translateService.instant("Yes") }}</button>
    }
    @if (hasNo()) {
        <button mat-button class="btn-themed" (click)="onNo()">{{ translateService.instant("No") }}</button>
    }

    @if (hasCancel()) {
        <button mat-button class="btn-themed" (click)="closeDialog()" cdkFocusInitial>
            {{ translateService.instant("Undo") }}
        </button>
    }
</mat-dialog-actions>
